import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralCookie } from "@/lib/referral";
import { captureAttributionCookie } from "@/lib/attribution";

function ReferralCapture() {
  const { search } = useLocation();

  useLayoutEffect(() => {
    captureReferralCookie();
    // Origem da visita (UTMs do anúncio). Mesma ideia do ?ref= acima: ler na
    // chegada e guardar, porque o cadastro acontece depois — às vezes dias
    // depois, em outra página.
    captureAttributionCookie();
  }, [search]);

  return null;
}

export default ReferralCapture;
